import styled from "styled-components"

export const AddButtonWrapper = styled.div`
  svg {
    width: 18px !important;
    height: 18px !important;
  }
`
